import { useQuery } from "@tanstack/react-query";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import api from "@/lib/axios";
import { useSearchParams } from "react-router-dom";
import { useTahun } from "@/hooks/useTahun";

const getListDataPendaftaranPasca = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string,
  idsUk: string,
  idsSysPeriode: string,
  statusValidasi: string,
  statusKelulusan: string,
  statusDaftarkembali: string,
  tahunParams?: string
) => {
  const response = await api.get(
    `/operator-pasca/data-pendaftaran/index?page=${page}${
      rowsPerPage ? `&rowsPerPage=${rowsPerPage}` : ""
    }${searchQuery ? `&searchQuery=${searchQuery}` : ""}${
      idsUk ? `&ids_uk=${idsUk}` : ""
    }${idsSysPeriode ? `&ids_sys_periode=${idsSysPeriode}` : ""} ${
      statusValidasi ? `&status_validasi=${statusValidasi}` : ""
    } ${statusKelulusan ? `&status_kelulusan=${statusKelulusan}` : ""}${
      statusDaftarkembali ? `&status_daftarkembali=${statusDaftarkembali}` : ""
    }${tahunParams ? `&tahun=${tahunParams}` : ""}`,
    {
      withCredentials: true,
    }
  );
  return response.data?.data;
};

export default function DataPendaftaranPascaPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const rowsPerPageParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const idsUkParams = searchParams.get("ids_uk");
  const idsSysPeriodeParams = searchParams.get("ids_sys_periode");
  const statusValidasiParams = searchParams.get("status_validasi");
  const statusKelulusanParams = searchParams.get("status_kelulusan");
  const statusDaftarkembaliParams = searchParams.get("status_daftarkembali");

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataPendaftaran",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      idsUkParams,
      idsSysPeriodeParams,
      statusValidasiParams,
      statusKelulusanParams,
      statusDaftarkembaliParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListDataPendaftaranPasca(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        idsUkParams as string,
        idsSysPeriodeParams as string,
        statusValidasiParams as string,
        statusKelulusanParams as string,
        statusDaftarkembaliParams as string,
        selectedTahun?.label
      ),
  });

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
        isPending={isPending}
      />
    </div>
  );
}
